/**
 * session_attendance uses status 'absent' for late cancellations.
 * Keep display labels aligned with therapist-facing terminology.
 */
export function formatAttendanceStatusLabel(status) {
  if (!status) return '';
  switch (status) {
    case 'absent':
      return 'Late Cancellation';
    case 'present':
      return 'Present';
    case 'cancelled':
      return 'Cancelled';
    default:
      return String(status).charAt(0).toUpperCase() + String(status).slice(1);
  }
}

export function getAttendanceStatusColorScheme(status) {
  switch (status) {
    case 'present':
      return 'green';
    case 'absent':
      return 'red';
    case 'cancelled':
      return 'orange';
    default:
      return 'gray';
  }
}

export function isCancelledOrLateCancellationStatus(status) {
  return status === 'cancelled' || status === 'absent';
}

/** e.g. "May 23, 2026" — used for therapist-void makeup badges across schedule + logs. */
export function formatMakeupBadgeDate(dateInput) {
  if (dateInput == null || dateInput === '') return '';
  try {
    return new Date(dateInput).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return String(dateInput);
  }
}
